<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card v-if='!maintenance' :color="cardColor" :text="message" title="EMN Logistic - Login">
          <v-form ref="form" v-model="validForm">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field id="input_login" v-model="loginForm.username" :rules="validators.username"
                    prepend-icon="mdi-account" name="login" label="Login" type="text" required />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field id="input_password" v-model="loginForm.password" :append-icon="passwordType == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    " :type="passwordType" :rules="[validators.password]" prepend-icon="mdi-lock" name="password"
                    label="Password" required @click:append="showPwd" />
                </v-flex>

                <v-flex xs6 text-left>
                  <br>
                  <a @click="resetPass">Reset password</a>
                </v-flex>

                <v-flex xs6 text-right>
                  <v-btn id="button_login" :disabled="!validForm" color="primary" class="mx-0 font-weight-light"
                    @click="login">Login</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

        </material-card>
        <v-alert v-else type='error' prominent style="text-align:left">
          <h3>{{ maintenance.title }}</h3>
          <div v-html="maintenance.message" />
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from '@/utils/validators'
import { mapState } from 'vuex'


export default {
  data: () => ({
    validForm: true,
    validators,
    loginForm: {
      username: '',
      password: '',
    },
    passwordType: 'password',
    message: 'Please insert your credentials',
    cardColor: 'primary',
    renderParams: {
      width: 250,
      height: 50,
      longtitle: true,
    }
  }),
  computed: {
    ...mapState('app', ['config']),
    maintenance() {
      if (this.config.maintenance) {
        return this.config.maintenance.filter((el) => {
          return !el.allowLogin
        })[0]
      }
      return false
    },
  },
  mounted() {
  },
  methods: {
    login() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$store
        .dispatch('user/login', this.loginForm)
        .then(() => {
          this.cardColor = 'success'
          const path = this.$route.query.redirect || '/'
          this.$router.push({ path })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.message = e.message
          this.cardColor = 'error'
        })
    },
    resetPass() {
      this.$router.push({ path: '/reset-pass' })
    },
    showPwd() {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    }
  }
}
</script>


<style scoped>
.form-separator {
  height: 12px;
  margin: 0px 0px 20px 0px;
  text-align: center;
  border-bottom: 1px solid #e4e5e7;
}

.form-separator span {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 0 8px;
  background-color: #fff;
  color: #62646a;
}

.googleButton {
  margin: auto;
  min-width: 130px;
  background-color: #f4f4f4;
  border: 1px solid gray;
  text-align: left;
  margin-top: 15px;
}

.googleButton span {
  position: absolute;
  margin-top: 7px;
}
</style>